import { Navigate, useSearchParams } from "react-router-dom";
import { useCerberus } from "../../hooks/useCerberus";
import Login from "./Login";
import { getPostLoginRedirectUrl } from "../../utils/redirectUtils";

const LoginRoute = () => {
  const { loading, isRegistered } = useCerberus();
  const [searchParams] = useSearchParams();

  if (loading) {
    return null;
  }

  if (isRegistered) {
    const redirectUrl = getPostLoginRedirectUrl(searchParams);
    return <Navigate to={redirectUrl} replace />;
  }

  return <Login />;
};

export default LoginRoute;
